import { getTopicSuffixes } from '@zg-rentals/satellite-web-socket-helpers';

// On the inbox route the conversation id is index 1 of the catch-all `conversationSlug`
// (`[listingAlias, conversationId]`, built by `buildConversationSlug`), undefined when only a
// listing is selected. (Lead-management uses the `messagingConversationId` query param instead.)
export const getInboxConversationId = (conversationSlug: string | Array<string> | undefined): string | undefined =>
  Array.isArray(conversationSlug) ? conversationSlug[1] : undefined;

type GetWebSocketTopicSuffixesOptions = {
  listingAlias?: string;
  conversationId?: string;
  isLeadManagement: boolean;
};

/**
 * Builds the satellite-websocket topic suffixes the SLW `WebSocketProvider` subscribes to for the
 * current route:
 * - **Lead management:** `|leadManagement` always, plus `|conversation:{id}:landlord` when the
 *   RenterMessagingModal is open so its message list receives `newMessage` frames. The lead table
 *   itself reacts only to the list-level `conversationUpdated` on `|leadManagement`.
 * - **Inbox:** `|inbox:landlord` plus `|conversation:{id}:landlord` (via `getTopicSuffixes`), plus
 *   `|listing:{listingAlias}` when a listing is in scope.
 */
export const getWebSocketTopicSuffixes = ({
  listingAlias,
  conversationId,
  isLeadManagement,
}: GetWebSocketTopicSuffixesOptions): Array<string> => {
  if (isLeadManagement) {
    const suffixes = ['|leadManagement'];
    if (conversationId) {
      suffixes.push(`|conversation:${conversationId}:landlord`);
    }
    return suffixes;
  }
  const suffixes = getTopicSuffixes({ topic: 'landlord', conversationId });
  if (listingAlias) {
    suffixes.push(`|listing:${listingAlias}`);
  }
  return suffixes;
};
